import React from 'react'
import { observer } from 'mobx-react'
import EmbededEntityInput from '../../input/embedded_entity'
import OptionsField from 'react-mobx-admin/components/common/field/opts'
import TextField from 'react-mobx-admin/components/common/field/text'
import SelectWithSuggestions from '../../input/select_suggested'

const BundledFilmsEdit = ({ store, updateField, ...rest }) => {
  const _BundledFilmsEditForm = ({ store, record, updateFormField, errors }) => {
    return (
      <div className='row'>
        <div className='col-xs-12'>
          <SelectWithSuggestions
            label={store.__('Film')}
            attr={'film_slug'}
            record={record}
            onChange={updateFormField}
            optionsrecord={store.options}
            optionsattr={'films'}
            labelattr='title'
            valueattr='slug'
            errors={errors} />
        </div>
      </div>
    )
  }

  return (
    <EmbededEntityInput
      store={store}
      helper='films/common/bundledFilms'
      label={store.__('bundled films')}
      attr={'bundledFilms'}
      edit_title={store.__('edit film')}
      add_title={store.__('add film')}
      fields={[
        (attr, row) => (<OptionsField attr={attr} val={row[attr]}
          options={store.options.get('films')}
          labelattr='title' valueattr='slug' />),
      ]}
      rowId={(row) => (row.video_id)}
      EditForm={_BundledFilmsEditForm} {...rest}
    />
  )
}

// export default
export default observer(BundledFilmsEdit)
